import ModalDeleteDocument from './ModalDeleteDocument';

export default ModalDeleteDocument;
